import { createAsyncThunk } from '@reduxjs/toolkit';
import { getChatRooms, sendMessage } from 'src/api/stream/chat';

export const initChatRooms = createAsyncThunk('chat/initChatRooms', async (_, { rejectWithValue }) => {
  try {
    const res = await getChatRooms();
    return res.data;
  } catch (error: any) {
    return rejectWithValue(error?.error[0]?.msg ?? 'Error fetching chat rooms');
  }
});

export const fetchChatRooms = createAsyncThunk('chat/fetchChatRooms', async (_, { rejectWithValue }) => {
  try {
    const res = await getChatRooms();
    return res.data;
  } catch (error: any) {
    return rejectWithValue(error?.error[0]?.msg ?? 'Error fetching chat rooms');
  }
});

export const sendChatMessage = createAsyncThunk(
  'chat/fetchSendMessage',
  async ({ to, message }: { to: string; message: string }, { rejectWithValue }) => {
    try {
      const res = await sendMessage(to, message);
      return res.data;
    } catch (error: any) {
      return rejectWithValue(error?.error[0]?.msg ?? 'Error fetching chat rooms');
    }
  }
);
